import HARDCODE from '../../../business-const/HardCode/HardCode'



export const processaRegistrosDefaultIniciaisSimulacaoFinanceiraAporteRetiradaAnual = ( values ) => {

    if (!values.aporteRetiradaAnual) {

        values.aporteRetiradaAnual = JSON.parse(JSON.stringify(HARDCODE.aporteRetiradaAnualInit))
    }
}